import MessageWarn from "./messwarn"

const Messwarn = {
	install(Vue){
		Vue.component('Messwarn',MessageWarn)
	}
}

export default Messwarn